"use strict";

import angular from "angular";

const __nandaSpeech = {
    name: "nandaSpeech",
    factory: [
        function () {
            return {
                link($scope, $element, $attrs) {
                    function speak(text, end) {
                        var msg = new SpeechSynthesisUtterance();
                        msg.voiceURI = "native";
                        msg.volume = 0.9;
                        msg.rate = 1.1;
                        msg.pitch = 0.8;
                        msg.text = text;
                        msg.lang = "pt-BR";
                        msg.onend = function () {
                            if (end) end();
                            $scope.$root.nandaSpeaking = false;
                        };
                        $scope.$root.nandaSpeaking = true;
                        speechSynthesis.speak(msg);
                    }
                    $element.bind("click", function () {
                        const raw = $attrs.nandaSpeech || "";
                        const text = raw.replace(/<[^>]*>?/gm, "");
                        const speechOn = $attrs.nandaSpeechOn;
                        speechOn === "false" ? "" : speak(text);
                    });
                }
            };
        }
    ]
};
angular.module("nucont.shared").directive(
    __nandaSpeech.name,
    __nandaSpeech.factory
);
export default __nandaSpeech;
